<template>

    <div>

      <div class="panel panel-default">

        <div class="panel-heading">
          {{ formInputParameter.key }}
        </div>

        <div class="panel-body">

          <div
            v-for="formCheckbox of formInputParameter.form_checkbox_group"
            v-bind:key="formCheckbox.key"
            class="checkbox" >

            <input
              v-bind:id="'jt-form-input-' + formCheckbox.key"
              v-bind:name="'jt-form-input-' + formCheckbox.key"
              v-bind:ref="'jt-form-input-' + formCheckbox.key" 
              type="checkbox"
              class="form_checkbox_group" 
              v-bind:data-key="formCheckbox.key"
              v-bind:true-value="1"
              v-bind:false-value="0"
              v-model="formData[formCheckbox.key]" >

            <label
              v-bind:for="'jt-form-input-' +formCheckbox.key"
              class="column-p-lbl">
              {{ formCheckbox.text }}
            </label>

          </div>

        </div>

      </div>

    </div>

</template>

<script>

export default {
  name: "AppFormInputCheckboxGroup",
  props: ['value', 'formIsAdd', 'formInputParameter', 'formData'],
  data () {
    return {
      inputError: null
    }
  },
  mounted() {
    for(let formCheckbox of this.formInputParameter.form_checkbox_group) {
      try {
        var self = this;

        $('input[id="jt-form-input-' + formCheckbox.key + '"]').iCheck({
          checkboxClass: 'icheckbox_square-green',
          radioClass: 'iradio_square-green'
        }).on('ifChanged', function(e) {
          $(e.target).trigger('change');//.change();
          self.onInputChanged();
          self.formData[$(e.target).data('key')] = $(e.target).is(':checked') ? 1 : 0;
        });
      } catch (e) {
      }
    }
  },
  updated: function () {
    for(let formCheckbox of this.formInputParameter.form_checkbox_group) {
      try {
        $('input[id="jt-form-input-' + formCheckbox.key + '"]').iCheck('update');
      } catch (e) {
      }
    }
  },
  methods: {
    onInputChanged() {
      this.$emit('change');
    },
    
    setInputError(inputError) {
      this.inputError = inputError;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppFormInputCheckboxGroup.vue